export default __webpack_public_path__ + "static/kia_white-ceaac03ec56242b0dcdf07c306b95af0.jpg";